import BaseColumn, {
  ColumnProps as BaseColumnProps,
} from 'antd/lib/table/Column'

export interface ColumnProps<RecordType> extends BaseColumnProps<RecordType> {}

export function Column<RecordType>(
  props: ColumnProps<RecordType>
): JSX.Element {
  return (
    <>
      <BaseColumn<RecordType> {...props} />
    </>
  )
}
